import { Dispatch } from 'redux';
import FLUX_UPDATEPASS_CONSTANTS from '../constants/updatePass-constants';
import { API } from "../api/updatePass-api";

const upPasswordBegin = () => {
    return {
        type: FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_BEGIN
    }
}
const upPasswordSuccess = (data: any) => {

    return {
        type: FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_SUCCESS,
        data
    }
}
const upPasswordFailed = (e: any) => {

    return {
        type: FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_FAILED,
        error: e
    }

}


const upPasswordClear = () => {

    return {
        type: FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_CLEAR
    }

}


export const updatePassword = (data: any) => {


    return (dispatch: Dispatch) => {
        dispatch(upPasswordBegin());
        API.updatePassword(data).then((response: any) => {
            dispatch(upPasswordSuccess(response.data));

        }).catch((errors: any) => {
            dispatch(upPasswordFailed(errors.response));
        })
    }
}


export const clearPassword = () => {

    return (dispatch: Dispatch) => {
        dispatch(upPasswordClear())
    }
}